export default __webpack_public_path__ + "src/assets/node-logo.74b2e4c68f23e8ebecc43fa04a3d9e2a.svg";